import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from "../../assets/images/bluesky-vue-logo.png";
import classnames from "classnames";
import LinearProgress from "@material-ui/core/LinearProgress";
import TextField from "@material-ui/core/TextField";
import { resetPassword } from "../../services";

var { version: appVersion } = require("../../../package.json");

export const ResetPassword = props => {
  const { token, username } = props.match.params;
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [resetComplete, setResetComplete] = useState(false);

  const attemptResetPassword = async (evt, password, passwordConfirmed) => {
    evt.preventDefault();
    setLoadError("");

    const failureMessage = validatePasswords(password, passwordConfirmed);
    if (failureMessage) {
      setLoadError(failureMessage);
    }
    else {
      try {
        setLoading(true);
        await resetPassword(username, password, token);
        setLoading(false);

        setResetComplete(true);
      } catch (error) {
        setLoading(false);
        setLoadError("Something went wrong, please try again");
      }
    }
  };

  const validatePasswords = (password1, password2) => {
    var passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9_])(?=.{6,})");
    if (passwordRegex.test(password1) == false) {
      return "Password must be at least 6 characters long, contain a lowercase letter, uppercase letter, digit, and non-alphanumeric character";
    }
    else if (password1 != password2) {
      return "New password and password confirmation must match";
    }
  }

  return (
    <div className={classnames("app", "login-background", "col-center-center")}>
      <div className={classnames("login-card", "row-between-center")}>
        <div className={classnames("login-card-left", "col-center-center")}>
          <img
            src={logo}
            alt={"BlueSky Vue Logo"}
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
        <div className={classnames("login-card-right", "col-center-center")}>
          <div
            style={{
              marginBottom: 10,
              fontWeight: "bold",
              fontSize: 28,
              color: "var(--jmi-blue)"
            }}
          >
            RESET PASSWORD
          </div>
          { resetComplete ?
            <div
              style={{ marginTop: 20 }}
              className={classnames("col-center-center", "full-width")}
            >
              <Link className="forgot-password-label" to={`/login`}>
                Back to Login
              </Link>
            </div>
            :
            <form
              id="forgot-password-form"
              style={{ width: "90%" }}
              onSubmit={evt => attemptResetPassword(evt, newPassword, newPasswordConfirm)}
            >
              <div className="col-start-start">
                <label>New Password</label>
                <TextField
                  value={newPassword}
                  type="password"
                  margin="dense"
                  variant="outlined"
                  inputProps={{ "aria-label": "bare" }}
                  style={{ width: "100%" }}
                  onChange={evt => setNewPassword(evt.target.value)}
                />
              </div>
              <div className={classnames("col-start-start")} style={{ marginTop: 20 }}>
                <label>Confirm New Password</label>
                <TextField
                  value={newPasswordConfirm}
                  type="password"
                  margin="dense"
                  variant="outlined"
                  inputProps={{ "aria-label": "bare" }}
                  style={{ width: "100%" }}
                  onChange={evt => setNewPasswordConfirm(evt.target.value)}
                />
              </div>
              <div
                style={{ marginTop: 20 }}
                className={classnames("row-between-center", "full-width")}
              >
                <Link className="forgot-password-label" to={`/login`}>
                  Back to Login
                </Link>
                <button type="submit" className="login-submit-button">
                  Submit
                </button>
              </div>
            </form>
          }
          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              marginTop: 10,
              marginBottom: 25,
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div
              style={{
                width: "90%"
              }}
            >
              {loadError && <div style={{ color: "#c33" }}>{loadError}</div>}
              {loading && <LinearProgress />}
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 25, color: "#aaa", fontSize: 14 }}>
        Version {appVersion}
      </div>
    </div>
  );
};

ResetPassword.propTypes = {};
